import { OrderListContainer } from './list/container';
import { OrderReceiptContainer } from './receipt/container';
import { OrderViewContainer } from './view/container';

export const OrderListRoute = OrderListContainer;

export const OrderViewRoute = OrderViewContainer;

export const OrderReceiptRoute = OrderReceiptContainer;
